exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container{margin-top:2rem}.navbar{list-style-type:none}.payu-info-credit{color:teal}", ""]);

// exports
